var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBusiness2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 55 55",
    width: 55,
    height: 55,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.71 12.26C18.9 13.28 13.93 14.34 13.93 14.34C12.34 14.68 11.22 16.19 10.98 18.04C10.94 18.04 10.68 18.1 10.64 18.11C9.57 18.34 8.87 19.4 9.1 20.48C9.14 20.67 9.48 22.24 9.52 22.44C9.72 23.37 10.55 24.02 11.48 24.02C11.61 24.02 11.75 24.01 11.89 23.98C11.93 23.97 12.2 23.91 12.23 23.9C13.07 25.27 14.39 26.15 15.76 26.15C15.98 26.15 16.2 26.13 16.43 26.08C16.43 26.08 17.2 25.92 18.43 25.65C18.74 26.35 21.15 31.97 21.45 32.67C21.86 33.61 22.78 34.18 23.75 34.18C23.92 34.18 24.1 34.16 24.27 34.13C24.43 34.09 24.59 34.04 24.74 33.98C26.01 33.43 26.59 31.96 26.05 30.69C25.79 30.08 23.68 25.2 23.42 24.59C24.32 24.4 25.26 24.2 26.21 24C26.66 23.9 27.15 23.86 27.66 23.86C31.02 23.86 35.44 25.71 38.09 26.98C38.12 27.14 38.39 28.4 38.42 28.56C38.64 29.56 39.29 30.23 40.05 30.23C40.13 30.23 40.22 30.22 40.31 30.21C40.81 30.1 41.2 29.69 41.35 29.12C41.44 28.76 41.45 28.35 41.36 27.94C41.17 27.04 39.65 19.88 39.46 18.99C41.05 18.2 41.98 16.42 41.59 14.6C41.2 12.78 39.63 11.52 37.85 11.44C37.66 10.55 36.15 3.4 35.96 2.5C35.74 1.5 35.09 0.83 34.33 0.83C34.24 0.83 34.16 0.84 34.07 0.86C33.57 0.97 33.18 1.37 33.03 1.95C32.93 2.3 32.93 2.71 33.02 3.13C33.04 3.23 33.15 3.76 33.35 4.7C29.14 9.27 25.93 11.79 23.71 12.26ZM11.48 23.02C11.01 23.02 10.59 22.69 10.5 22.23C10.46 22.03 10.12 20.47 10.08 20.27C9.97 19.73 10.31 19.2 10.85 19.09C10.86 19.08 10.92 19.07 10.93 19.07C10.95 19.4 10.99 19.73 11.06 20.06C11.1 20.26 11.43 21.82 11.48 22.02C11.55 22.36 11.65 22.67 11.77 22.98C11.76 22.98 11.73 22.99 11.68 23C11.59 23.01 11.52 23.02 11.48 23.02ZM25.15 32.23C25 32.61 24.71 32.9 24.35 33.06C24.25 33.1 24.16 33.13 24.06 33.15C23.96 33.17 23.86 33.18 23.75 33.18C23.15 33.18 22.61 32.83 22.38 32.27C22.08 31.59 19.72 26.13 19.43 25.44C20.31 25.26 21.33 25.04 22.42 24.81C22.6 25.22 23.5 27.32 25.13 31.09C25.24 31.6 25.24 31.99 25.15 32.23ZM26 23.02C25.02 23.23 17.2 24.89 16.22 25.1C16.07 25.13 15.91 25.15 15.76 25.15C14.28 25.15 12.86 23.72 12.45 21.81C12.41 21.62 12.08 20.05 12.04 19.86C11.81 18.78 11.93 17.7 12.37 16.81C12.77 16.01 13.4 15.48 14.14 15.32C15.12 15.11 22.94 13.45 23.92 13.24C27.28 12.53 31.22 8.62 33.61 5.92C34.03 7.91 37.4 23.77 37.83 25.75C35.06 24.47 30.94 22.86 27.66 22.86C27.06 22.86 26.51 22.92 26 23.02ZM40.19 17.06C39.95 17.45 39.61 17.74 39.24 17.97C39.12 17.42 38.18 13.01 38.07 12.46C39.31 12.63 40.35 13.56 40.61 14.81C40.78 15.59 40.63 16.39 40.19 17.06ZM34.33 1.83C34.59 1.83 34.87 2.21 34.98 2.71C35.52 5.26 39.84 25.6 40.38 28.15C40.49 28.68 40.37 29.17 40.1 29.23C40.08 29.23 40.07 29.23 40.05 29.23C39.79 29.23 39.51 28.86 39.4 28.35C38.86 25.81 34.54 5.47 34 2.92C33.88 2.38 34.01 1.9 34.28 1.84C34.3 1.84 34.31 1.83 34.33 1.83Z",
    id: "d523KXAySW"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.45 4.01C45.45 4.01 45.45 4.01 45.45 4.01C42.83 8.03 41.38 10.27 41.08 10.72C41.08 10.72 41.08 10.72 41.08 10.72C40.58 10.39 40.3 10.21 40.25 10.17C40.25 10.17 40.25 10.17 40.25 10.17C42.86 6.15 44.32 3.91 44.61 3.46C44.61 3.46 44.61 3.46 44.61 3.46C45.11 3.79 45.39 3.97 45.45 4.01Z",
    id: "brh8pZuQT"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.45 19.55C42.45 19.55 42.45 19.55 42.45 19.55C42.78 19.05 42.96 18.77 43 18.71C43 18.71 43 18.71 43 18.71C47.02 21.32 49.26 22.78 49.71 23.07C49.71 23.07 49.71 23.07 49.71 23.07C49.38 23.57 49.2 23.85 49.16 23.91C49.16 23.91 49.16 23.91 49.16 23.91C45.14 21.29 42.9 19.84 42.45 19.55Z",
    id: "a24AFVrIjL"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.76 19L54 23.46L54 23.56L33.32 35.05L34.15 35.73L54 24.7L54 34.04L54 53.19C39.8 41.61 31.9 35.18 30.33 33.9C29.69 33.37 28.84 33.11 28 33.11C27.16 33.11 26.31 33.38 25.67 33.9C24.1 35.18 16.2 41.61 2 53.19L2 51.9L2 31.86L2 24.7L21.85 35.72L22.68 35.04L2 23.56L2 23.46C17.08 10.62 25.45 3.49 27.13 2.06C27.35 1.87 27.67 1.76 28 1.76C28.33 1.76 28.65 1.87 28.87 2.06C29.11 2.26 30.29 3.26 32.41 5.07L32.07 3.47C30.54 2.16 29.69 1.44 29.52 1.3C29.1 0.94 28.55 0.76 28 0.76C27.45 0.76 26.9 0.94 26.48 1.3C24.78 2.74 16.29 9.98 1 23L1 31.89L1 52.71L1 54L2 54L54 54L55 54L55 34.05L55 23L50.31 19L48.76 19ZM26.31 34.67C26.74 34.32 27.36 34.11 28 34.11C28.64 34.11 29.26 34.32 29.69 34.67C31.19 35.89 38.69 42 52.19 53L3.81 53C17.31 42 24.81 35.89 26.31 34.67Z",
    id: "b6YNsAfcLs"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.76 16.38C43.76 16.38 43.76 16.38 43.76 16.38C43.79 15.78 43.81 15.45 43.81 15.38C43.81 15.38 43.81 15.38 43.81 15.38C48.61 15.63 51.27 15.77 51.8 15.8C51.8 15.8 51.8 15.8 51.8 15.8C51.77 16.4 51.75 16.73 51.75 16.8C51.75 16.8 51.75 16.8 51.75 16.8C46.95 16.55 44.29 16.41 43.76 16.38Z",
    id: "c1RJjUkvz"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3 12.98C43.3 12.98 43.3 12.98 43.3 12.98C43.03 12.44 42.88 12.15 42.85 12.09C42.85 12.09 42.85 12.09 42.85 12.09C47.12 9.91 49.5 8.7 49.97 8.45C49.97 8.45 49.97 8.45 49.97 8.45C50.25 8.99 50.4 9.29 50.43 9.35C50.43 9.35 50.43 9.35 50.43 9.35C46.15 11.53 43.78 12.74 43.3 12.98Z",
    id: "f69iymehz"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d523KXAySW",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d523KXAySW",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#brh8pZuQT",
    opacity: 1,
    fill: "#00af60",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#brh8pZuQT",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a24AFVrIjL",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a24AFVrIjL",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b6YNsAfcLs",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b6YNsAfcLs",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c1RJjUkvz",
    opacity: 1,
    fill: "#00af60",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c1RJjUkvz",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f69iymehz",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f69iymehz",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusiness2);
export default __webpack_public_path__ + "static/media/business-2.4950221f280cc49e1d98aeb1774f026d.svg";
export { ForwardRef as ReactComponent };